<template>
  <div class="c-position-warp">
    <div class="c-position">
      <Icon v-for="pos of poses" :key="pos" :class="current(pos)" type="ios-square" @click.stop="$emit('input', pos)" />
    </div>
    <div v-if="!validate" class="g-error-text">位置不能为空</div>
  </div>
</template>
<script>
import { isEmpty } from '@/common/js/utils'
export default {
  name: 'Position',
  props: {
    value: {
      type: String
    },
    verify: {
      type: Boolean
    }
  },
  computed: {
    current() {
      return (pos) => {
        return { 'c-pos-active': this.value === pos }
      }
    },
    validate() {
      return this.verify ? !isEmpty(this.value) : true
    }
  },
  data() {
    return {
      poses: ['top-left', 'top', 'top-right', 'left', 'center', 'right', 'bottom-left', 'bottom', 'bottom-right']
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~common/styles/element-ui/variables.scss';

.c-position-warp {
  margin-bottom: 12px;

  .c-position {
    width: 80px;
    padding: 3px 4px;
    border-radius: 3px;
    border: solid 1px #ddd;
    line-height: 2;

    &:hover {
      border-color: $primary-color;
    }

    .ivu-icon {
      font-size: 22px;
      color: #d7d7d7;
      margin-right: 2px;

      &:nth-child(3n) {
        margin-right: 0;
      }
    }

    .c-pos-active {
      color: $primary-color;
    }
  }
}
</style>
